import { NgModule, ModuleWithProviders } from '@angular/core'
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';

import { O2TourComponent } from './o2-tour.component';
import { defaultToastConfig, O2Tour_CONFIG_TOKEN } from './o2-tour-config';
import {BrowserModule} from '@angular/platform-browser';

@NgModule({
  imports: [BrowserModule, OverlayModule, MatIconModule],
  declarations: [O2TourComponent],
  entryComponents: [O2TourComponent]
})
export class O2TourModule {
  public static forRoot(config = defaultToastConfig): ModuleWithProviders {
        return {
            ngModule: O2TourModule,
            providers: [
                {
                    provide: O2Tour_CONFIG_TOKEN,
                    useValue: { ...defaultToastConfig, ...config },
                },
            ],
        };
    }
}




// WEBPACK FOOTER //
// ./src/app/o2-tour/o2-tour.module.ts